import { TypedDocumentNode } from 'apollo-angular';
import { TnAvailableSearchResults } from '@nuso/cpaas/types';
import { gql } from 'graphql-tag';

export const tnAvailableSearchQuery: TypedDocumentNode<TnAvailableSearchResults> = gql`
  query tnAvailableSearch($input: TnAvailableSearchInput) {
    tnAvailableSearch(input: $input) {
      availableTns {
        id
        tn # deprecated
        tnE164
        lata
        lataName
        rateCenter
        state
        npa
        nxx
        level
        isReservable
        country
      }
    }
  }
`;

export const tnAvailableIntlSearchQuery: TypedDocumentNode<TnAvailableSearchResults> = gql`
  query tnAvailableIntlSearch($input: TnAvailableIntlSearchInput) {
    tnAvailableIntlSearch(input: $input) {
      availableTns {
        id
        tn # deprecated
        tnE164
        stdAreaCode
        location
        level
        isReservable
        country
      }
    }
  }
`;

export const fetchLergDataQuery = gql`
  query lergSearch($input: LergSearchInput) {
    lergSearch(input: $input) {
      id
      countries {
        label
        value
      }
      latas {
        label
        value
      }
      npas {
        label
        value
      }
      nxxs {
        label
        value
      }
      rateCenters {
        label
        value
      }
      states {
        label
        value
      }
    }
  }
`;

export const fetchIntlLocationDataQuery = gql`
  query intlLocationSearch($input: IntlLocationSearchInput) {
    intlLocationSearch(input: $input) {
      id
      countries {
        label
        value
      }
      locations {
        label
        value
      }
      stdAreaCodes {
        label
        value
      }
    }
  }
`;
